import { render, staticRenderFns } from "./HudShape.vue?vue&type=template&id=1766ad84&scoped=true&"
import script from "./HudShape.vue?vue&type=script&lang=js&"
export * from "./HudShape.vue?vue&type=script&lang=js&"
import style0 from "./HudShape.vue?vue&type=style&index=0&id=1766ad84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766ad84",
  null
  
)

export default component.exports